import PositionModel from '../model/PositionModel'
import TextControl from '../../../lib/ui/TextControl'
import PickerControl from '../../../lib/ui/PickerControl'
import SelectPerson from '../../person/action/SelectPerson'
import SelectLocation from '../../location/action/SelectLocation'
import PhonenumberControl from '../../../lib/ui/PhonenumberControl'
import FaxnumberControl from '../../../lib/ui/FaxnumberControl'
import EmailControl from '../../../lib/ui/EmailControl'
import CheckboxControl from '../../../lib/ui/CheckboxControl'
import DateControl from '../../../lib/ui/DateControl'

export default class PositionForm {
  constructor (element, args) {
    let fieldsetPosition = document.createElement('fieldset')
    let legendPosition = document.createElement('legend')
    legendPosition.innerHTML = 'Functie'
    fieldsetPosition.appendChild(legendPosition)
    let popup = null

    this.id = args.position.values.id
    this.person = new PickerControl(fieldsetPosition, {label: 'Persoon', value: args.position.values.person_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectPerson(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.person.setValue(item.values.id, item)
            } else {
              this.person.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.person.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.location = new PickerControl(fieldsetPosition, {label: 'Vestiging', value: args.position.values.location_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/locations/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectLocation(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.location.setValue(item.values.id, item)
            } else {
              this.location.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.person.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.title = new TextControl(fieldsetPosition, {label: 'Titel', value: args.position.values.title, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})
    this.department = new TextControl(fieldsetPosition, {label: 'Afdeling', value: args.position.values.department, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})
    this.start = new DateControl(fieldsetPosition, {label: 'Start', value: args.position.values.start, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})
    this.end = new DateControl(fieldsetPosition, {label: 'Einde', value: args.position.values.end, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})

    let fieldsetContact = document.createElement('fieldset')
    let legendContact = document.createElement('legend')
    legendContact.innerHTML = 'Contact gegevens'
    fieldsetContact.appendChild(legendContact)

    this.phone = new PhonenumberControl(fieldsetContact, {label: 'Telefoon', value: args.position.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})
    this.mobile = new PhonenumberControl(fieldsetContact, {label: 'Mobiel', value: args.position.values.mobile, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})
    this.fax = new FaxnumberControl(fieldsetContact, {label: 'Fax', value: args.position.values.fax, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})
    this.email = new EmailControl(fieldsetContact, {label: 'E-mail', value: args.position.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})

    let fieldsetOptions = document.createElement('fieldset')
    let legendOptions = document.createElement('legend')
    legendOptions.innerHTML = 'Opties'
    fieldsetOptions.appendChild(legendOptions)

    this.sendchristmasemail = new CheckboxControl(fieldsetOptions, {label: 'Kerstkaart per e-mail', value: args.position.values.sendchristmasemail, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})
    this.sendchristmascard = new CheckboxControl(fieldsetOptions, {label: 'Kerstkaart per post', value: args.position.values.sendchristmascard, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange})

    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetPosition)
    fragment.appendChild(fieldsetContact)
    fragment.appendChild(fieldsetOptions)

    element.appendChild(fragment)
  }

  getValue () {
    let position = new PositionModel()
    position.person = this.person.getItem()
    position.location = this.location.getItem()
    position.values.id = this.id
    position.values.person_id = this.person.getValue()
    position.values.location_id = this.location.getValue()
    position.values.title = this.title.getValue()
    position.values.department = this.department.getValue()
    position.values.start = this.start.getValue()
    position.values.end = this.end.getValue()
    position.values.phone = this.phone.getValue()
    position.values.mobile = this.mobile.getValue()
    position.values.fax = this.fax.getValue()
    position.values.email = this.email.getValue()
    position.values.sendchristmasemail = this.sendchristmasemail.getValue()
    position.values.sendchristmascard = this.sendchristmascard.getValue()
    return position
  }

  setValue (position) {
    this.id = position.values.id
    this.person.setValue(position.values.person_id, position.person)
    this.location.setValue(position.values.location_id, position.location)
    this.title.setValue(position.values.title)
    this.department.setValue(position.values.department)
    this.start.setValue(position.values.start)
    this.end.setValue(position.values.end)
    this.phone.setValue(position.values.phone)
    this.mobile.setValue(position.values.mobile)
    this.fax.setValue(position.values.fax)
    this.email.setValue(position.values.email)
    this.sendchristmasemail.setValue(position.values.sendchristmasemail)
    this.sendchristmascard.setValue(position.values.sendchristmascard)
  }
}



// WEBPACK FOOTER //
// ./js/modules/position/ui/PositionForm.js